/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Badge_FlagshipInputs */

const en_model_badge_flagship = /** @type {(inputs: Model_Badge_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagship`)
};

const id_model_badge_flagship = /** @type {(inputs: Model_Badge_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkuat`)
};

/**
* | output |
* | --- |
* | "Flagship" |
*
* @param {Model_Badge_FlagshipInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_badge_flagship = /** @type {((inputs?: Model_Badge_FlagshipInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Badge_FlagshipInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_badge_flagship(inputs)
	return en_model_badge_flagship(inputs)
});